import { Code, ConnectError } from "@bufbuild/connect";
import {
  PortalEventService,
  PortalEventServiceGetTicketsBonusMediaRequest,
} from "@spwn-portal/grpc";
import useSWRMutation from "swr/mutation";
import { useConnectClient } from "utility/connectWeb";

export type EventTicketBonusMedia = {
  eventId: string;
  ticketId: string;
  // アップロードされたファイルのID
  mediaId: string;
  // アップロードされたファイルの名前
  filename: string;
  // 特典名
  bonusName: string;
  // ダウンロード開始日時
  releaseAt?: Date;
  // ダウンロード期限
  expiredAt?: Date;
  // ダウンロードURL
  urlForDownload?: string;
};

export const useEventTicketsBonusMediaLazy = (
  eventId: string,
  ticketIds: string[]
) => {
  const connectClient = useConnectClient(PortalEventService);

  return useSWRMutation(
    ["getTicketsBonusMedia", eventId, ticketIds],
    async ([_, eventId, ticketIds]) => {
      if (ticketIds.length === 0) {
        console.warn("チケットが存在しないイベントです");
        return [];
      }

      try {
        const response = await connectClient.getTicketsBonusMedia(
          new PortalEventServiceGetTicketsBonusMediaRequest({
            eventId,
            ticketIds,
          })
        );
        return (
          response.ticketBonusMedia?.map<EventTicketBonusMedia>((bonus) => ({
            eventId,
            ticketId: bonus.ticketId,
            mediaId: bonus.mediaId,
            filename: bonus.filename,
            bonusName: bonus.bonusName,
            releaseAt: bonus.releaseAt
              ? new Date(Number(bonus.releaseAt))
              : undefined,
            expiredAt: bonus.expiredAt
              ? new Date(Number(bonus.expiredAt))
              : undefined,
            urlForDownload: bonus.urlForDownload,
          })) ?? []
        );
      } catch (e) {
        if (e instanceof ConnectError && e.code === Code.NotFound) {
          // 共有チケットだとエラーになるはずなのでここで無視する
          // ※現状エラーにはなっていない
          return [];
        }
        throw e;
      }
    }
  );
};
